<template>
  <section class="content-tasks">
    <div class="content-tasks-itens">
      <HeaderTitle :title="'Tarefas'" :image="'tasks'"/>
      <Breadcrumb :links="links"/>
      <div class="content-tasks-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
            <a @click="routerPage()" class="content--card-register" style="min-height: 267px">
              <img class="img-fluid" src="@/assets/img/image-plus.png" alt="image plus" title="image plus"/>
            </a>
          </div>
          <div class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="task in tasks.data" :key="task.id">
            <CardTasks :task="task"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HeaderTitle from '@/components/headers/HeaderTitle';
import CardTasks from '@/views/Tasks/components/CardTasks';
import Breadcrumb from '@/components/breadcrumb/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Planos',
          routerName: 'Plans'
        },
        {
          name: '',
          routerName: 'EditPlans'
        },
        {
          name: 'Tasks',
          routerName: 'Tasks'
        },
      ],
      task: {
        title: 'A Procastinação',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
      },
      planParams: this.$route.params
    }
  },
  computed: {
    ...mapGetters({
      tasks: 'Tasks/tasks',
      plan: 'Plans/plan'
    })
  },
  components: {
    HeaderTitle,
    CardTasks,
    Breadcrumb,
  },
  methods: {
    ...mapActions('Plans', ['consultPlans']),
    ...mapActions('Tasks', ['consultTasks']),
    routerPage(){
      this.$router.push({
        name: 'RegisterTask',
      })
    }
  },
  async mounted() {
    await this.consultPlans(this.planParams);
    await this.consultTasks({idPlan: this.planParams.id});
    this.links[1].name = this.plan.name;
  }
}
</script>

<style lang="scss">
.content-tasks {
  &-itens {
    .content-breadcrumb {
      padding-top: 0;
    }
  }
}
</style>
